import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative h-[400px] lg:h-[560px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Organized%20product%20sourcing%20dashboard%20displayed%20on%20a%20modern%20tablet%20surrounded%20by%20curated%20fashion%20mood%20board%20materials%20fabric%20swatches%20product%20photos%20and%20handwritten%20notes%20on%20a%20warm%20oak%20desk%20soft%20natural%20window%20light%20editorial%20photography%20creative%20workspace%20clean%20minimal%20aesthetic&width=1000&height=800&seq=cta-v2-product&orientation=portrait"
          alt="ItaobuySpreadsheet product sourcing guide"
          title="ItaobuySpreadsheet 2026 Sourcing Playbook"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/25 to-transparent"></div>
        <div className="absolute top-8 left-8">
          <span className="inline-block px-3 py-1 text-xs font-medium text-white bg-white/20 backdrop-blur-sm rounded-full">
            NEW GUIDE
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight">
            2026 Product
            <br />
            Sourcing
            <br />
            Playbook
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-12 lg:p-16">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
            Read Our Latest
            <br />
            SEO Sourcing Guide
          </h2>
          <p className="text-sm text-foreground-600 mt-6 leading-relaxed text-left">
            The modern e-commerce landscape demands speed, precision, and
            structured data intelligence. The{" "}
            <strong>itaobuyspreadsheet</strong> system was built from the ground
            up to solve the biggest pain point in{" "}
            <strong>product sourcing</strong>: scattered, unstructured
            information. Whether you are a seasoned{" "}
            <strong>dropshipping</strong> seller managing hundreds of SKUs or a
            newcomer looking for your first winning product, having a{" "}
            <strong>product sourcing spreadsheet</strong> that centralizes
            real-time supplier data, pricing trends, and category insights gives
            you an undeniable competitive advantage. Our comprehensive guide
            walks you through every feature of the itaobuy spreadsheet ecosystem—
            from smart tracking and price intelligence to supplier comparison and
            export workflows designed specifically for Amazon sellers, wholesale
            importers, and e-commerce agencies.
          </p>
          <Link
            to="/articles/itaobuy-sheet-sourcing-guide"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 bg-foreground-950 text-background-50 font-medium text-sm rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}